import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { CorePartialStoreState } from './core.reducer';
import * as CoreSelectors from './core.selectors';

@Injectable()
export class CoreFacade {
    regionLanguages$ = this.store.select(CoreSelectors.getRegionLanguage);
    regionCountryCode$ = this.store.select(CoreSelectors.getRegionCountryCode);
    regionResetTicketsTime$ = this.store.select(CoreSelectors.getRegionResetTicketsTime);
    selectedLanguage$ = this.store.select(CoreSelectors.getSelectedLanguage);

    constructor(private store: NgRedux<CorePartialStoreState>) {}
}
